import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MaxDecimalsDirective } from './max-decimals.directive';
import { ClickableCardDirective } from './clickable-card/clickable-card.directive';
import { ClickableCardOverlayComponent } from './clickable-card/clickable-card.component';
import { PreventSpecialCharactersDirective } from './prevent-special-characters.directive';
import { DisableMenuIfDisabledChildrenDirective } from './menu-disable-children/menu-disable-children.directive';

@NgModule({
  declarations: [
    MaxDecimalsDirective,
    ClickableCardDirective,
    ClickableCardOverlayComponent,
    PreventSpecialCharactersDirective,
    DisableMenuIfDisabledChildrenDirective
  ],
  imports: [
    CommonModule,
    MatIconModule,
  ],
  exports: [
    MaxDecimalsDirective,
    ClickableCardDirective,
    PreventSpecialCharactersDirective,
    DisableMenuIfDisabledChildrenDirective
  ],
  entryComponents: [
    ClickableCardOverlayComponent,
  ]
})
export class DirectivesModule { }